/**
 * USP Indicator - Smooth scroll to section and fade out on scroll
 */
class USPIndicator {
  constructor() {
    this.indicator = document.querySelector(".usp-indicator");
    if (!this.indicator) return;

    this.targetSelector = this.indicator.getAttribute("data-scroll-to");
    this.targetSection = document.querySelector(this.targetSelector);
    this.hasBeenHidden = false; // Track if indicator has been hidden

    this.init();
  }

  init() {
    // Smooth scroll on click
    this.indicator.addEventListener("click", (e) => {
      e.preventDefault();
      this.scrollToSection();
    });

    // Fade out on scroll
    this.setupScrollListener();
  }

  scrollToSection() {
    if (this.targetSection) {
      this.targetSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  setupScrollListener() {
    let ticking = false;

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  handleScroll() {
    if (!this.targetSection || this.hasBeenHidden) return;

    const targetRect = this.targetSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const allowance = 0; // buffer before fading out

    // Fade out when the target section is in view (with allowance)
    if (targetRect.top <= windowHeight - allowance && targetRect.bottom >= 0) {
      this.indicator.classList.add("fade-out");
      this.hasBeenHidden = true; // Mark as hidden permanently
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new USPIndicator();
  });
} else {
  new USPIndicator();
}
